import { CasinoGame } from '../hooks/use-casino-games';

const GAMES_PER_QUAD = 4;

export type TiledGroup = { kind: 'hero'; game: CasinoGame } | { kind: 'quad'; games: CasinoGame[] };

/** Each row starts on the opposite kind to the row above. */
export const toCheckerboardGroups = (data: CasinoGame[], groupsPerRow: number): TiledGroup[] => {
    const groups: TiledGroup[] = [];
    let index = 0;

    while (index < data.length) {
        const position = groups.length;
        const isHero = (Math.floor(position / groupsPerRow) + (position % groupsPerRow)) % 2 === 0;

        if (isHero) {
            groups.push({ kind: 'hero', game: data[index] });
            index += 1;
        } else {
            groups.push({ kind: 'quad', games: data.slice(index, index + GAMES_PER_QUAD) });
            index += GAMES_PER_QUAD;
        }
    }

    return groups;
};

export const tiledGroupKey = (group: TiledGroup, index: number) =>
    group.kind === 'hero' ? `hero-${group.game.id}` : `quad-${group.games[0]?.id}-${index}`;
